import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import "./header.css";
import logoImg from "../../assets/images/logo.png";

const Header = () => {
  const menuRef = useRef(null);
  const { t } = useTranslation();
  const [showIcon, setShowIcon] = useState(false);

  const menu_links = [
    {
      path: "#",
      title: "HOME",
    },
    {
      path: "#services",
      title: "SERVICES",
    },
    {
      path: "#projects",
      title: "PROJECTS",
    },
    {
      path: "#about",
      title: "ABOUT",
    },
  ];

  const toggleMenu = () => menuRef.current.classList.toggle("menu-active");

  const handleChangeLanguage = () => {
    const nextLng = i18next.language === "he" ? "en" : "he";

    i18next.changeLanguage(nextLng).then((t) => {
      t("key");
      document.body.dir = nextLng === "he" ? "rtl" : "ltr";
    });
  };

  return (
    <header className="header" id="home">
      <div className="container">
        <div className="nav-wrapper">
          <div className="logo">
            {showIcon ? (
              <div>
                <h2>Beno</h2>
                <p>Grow with us</p>
              </div>
            ) : (
              <img src={logoImg} />
            )}
          </div>

          <div className="navigator" ref={menuRef} onClick={toggleMenu}>
            <ul className="menu">
              {menu_links.map((item, index) => (
                <li key={index} className="menu-item">
                  <a href={item.path} className="menu-button">
                    {t(item.title)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="contact-deck" id="contact-button">
            <div className="lng-btn" onClick={handleChangeLanguage}>
              {i18next.language === "he" ? "ENG" : "HEB"}
            </div>

            <div className="secondary-btn">
              <i className="ri-customer-service-line"></i>
              <span>{t("LETS_TALK")}</span>
            </div>
          </div>

          <span className="mobile-menu">
            <div className="lng-btn" onClick={handleChangeLanguage}>
              {i18next.language === "he" ? "ENG" : "HEB"}
            </div>
            <i className="ri-menu-line" onClick={toggleMenu}></i>
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;
